import { render } from "./CommunicationPieChart.vue?vue&type=template&id=5895a3cf"
import script from "./CommunicationPieChart.vue?vue&type=script&lang=js"
export * from "./CommunicationPieChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__